import { Button, FieldError, Label, ListBox, Popover, Select as AriaSelect, SelectValue, Text } from 'react-aria-components';
import type { SelectProps as AriaSelectProps, ValidationResult } from 'react-aria-components';
import selectArrow from '@assets/icons/select-arrow.svg';



interface SelectProps<T extends object> extends Omit<AriaSelectProps<T>, 'children'> {
	label?: string;
	description?: string;
	errorMessage?: string | ((validation: ValidationResult) => string);
	items?: Iterable<T>;
	children: React.ReactNode | ((item: T) => React.ReactNode);
}


export const Select = <T extends object>(props: SelectProps<T>) => {
	const { label, description, errorMessage, children, items, ...otherProps } = props;

	return (
		<AriaSelect {...otherProps}>
			<Label>{label}</Label>
			
			<Button>
				<SelectValue />
				<span aria-hidden="true">
					<img src={selectArrow} alt='select-arrow-icon' />
				</span>
			</Button>

			{description &&
				<Text slot="description">{description}</Text>}

			<FieldError>{errorMessage}</FieldError>

			<Popover>
				<ListBox items={items}>{children}</ListBox>
			</Popover>

		</AriaSelect>
	)
}

export default Select;